var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "dynamic-wrapper"
  }, [_c("div", {
    staticClass: "active-wrapper"
  }, [_c("div", {
    staticClass: "dynamic-title"
  }, [_vm._v("活跃度统计图")]), _c("active-line")], 1), _c("div", {
    staticClass: "timeline-wrapper"
  }, [_c("div", {
    staticClass: "dynamic-title"
  }, [_vm._v("近期动态")]), _c("a-timeline", {
    staticClass: "padding24",
    staticStyle: {
      "margin-top": "35px"
    },
    attrs: {
      mode: "left"
    }
  }, _vm._l(_vm.timelineList, function (item, index) {
    return _c("a-timeline-item", {
      key: index,
      attrs: {
        color: item.color
      }
    }, [_c("p", [_vm._v(_vm._s(item.time))]), _vm._v(" " + _vm._s(item.title) + " ")]);
  }), 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };